<div style="margin-top:1%">
  <div class="text-center" style="font-weight:bold; font-size: 1.6em">SYNDICATE SETTLEMENT CLAIM FORM</div>
</div>

<!--<div class="row mt-4">
  <div class="col-md-12">
    Only use this Form if you want to request exclusion from (i.e., opt-out of) the proposed settlement class.
  </div>
</div>-->
<div class="row mt-4">
  <div class="col-md-12">
    If you are a Settlement Class Member as defined on page 2 of the Notice of Proposed Partial Class Action Settlement, Settlement Hearing, and Right to Appear (“Notice”) with respect to the purchase
    of insurance coverage from the Defendants described on page 2 of the Notice where the coverage incepted or renewed during the period from January 1, 1997, through April 15, 2025, you must
    complete the following form for each such insurance that you purchased or renewed and mail it to the address listed above in order to participate in the Settlement for such policies.  You may also
    complete the form online at <a href="https://www.SyndicateSettlement.com">www.SyndicateSettlement.com.</a> This claim form must be postmarked or submitted online or by email to
    <a href="mailto:info@SyndicateSettlement.com">info@SyndicateSettlement.com</a> by <br /><b>October 30, 2026</b>

  </div>
</div>
<div class="row mt-4">
  <div class="col-md-12">
    <form [formGroup]="claimForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate #formRef="ngForm">
      <div class="row lightgraybackground">
        <div class="col-md-12 text-center">
          Claimant Information
        </div>
      </div>
      <div class="row rowformat mt-4">
        <div class="col-md-6">
          <div class="form-group">
            <label for="name1"><b>Contact Name:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="name1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.name1.errors }" />
            <div *ngIf="submitted && f.name1.errors" class="invalid-feedback">
              <div *ngIf="f.name1.errors.required">This field is required</div>
              <div *ngIf="f.name1.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.name1.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.name1.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="name2"><b>Contact Title:</b></label>
            <input type="text" class="form-control" formControlName="name2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.name2.errors }" />
            <div *ngIf="submitted && f.name2.errors" class="invalid-feedback">
              <!--<div *ngIf="f.name2.errors.required">This field is required</div>-->
              <div *ngIf="f.name2.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.name2.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.name2.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-12">
          <div class="form-group">
            <label for="name3"><b>Company/Organization/Insured Name:</b></label>
            <input type="text" class="form-control" formControlName="name3" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.name3.errors }" />
            <div *ngIf="submitted && f.name3.errors" class="invalid-feedback">
              <!--<div *ngIf="f.name3.errors.required">This field is required</div>-->
              <div *ngIf="f.name3.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.name3.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.name3.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row lightgraybackground mt-4">
        <div class="col-md-12 text-center">
          Current Contact Information
        </div>
      </div>
      <div class="row rowformat mt-4">
        <div class="col-md-12">
          <div class="form-group">
            <label for="street1"><b>Address:</b> <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="street1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street1.errors }" />
            <div *ngIf="submitted && f.street1.errors" class="invalid-feedback">
              <div *ngIf="f.street1.errors.required">This field is required</div>
              <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.street1.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.street1.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-4">
          <div class="form-group">
            <label for="city"><b>City:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
            <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
              <div *ngIf="f.city.errors.required">This field is required</div>
              <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.city.errors.maxlength">This field must not be at greater 40 characters</div>
              <div *ngIf="f.city.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="state"><b>State:</b><span style="color:red" class="required"> *</span></label>
            <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
              <option value="">Please Select A State</option>
              <option *ngFor="let allstate of allStates">
                {{allstate.Name}}
              </option>
            </select>
            <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
              <div *ngIf="f.state.errors.required">This field is required</div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="zip"><b>Zip Code:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
            <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
              <div *ngIf="f.zip.errors.required">This field is required</div>
              <div *ngIf="f.zip.errors.pattern">
                US zip Code with format 99999 or 99999-9999 alone are accepted
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-6">
          <div class="form-group">
            <label for="phone1"><b>Phone Number/Extension:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="phone1" placeholder="" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.phone1.errors }" />
            <div *ngIf="submitted && f.phone1.errors" class="invalid-feedback">
              <div *ngIf="f.phone1.errors.required">This field is required</div>
              <div *ngIf="f.phone1.errors.minlength">This field must be at least 10 digits</div>
              <div *ngIf="f.phone1.errors.maxlength">This field must not be at greater 10 digits</div>
              <div *ngIf="f.phone1.errors.pattern">Only use numbers</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="emailAddress"><b>Email Address:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.emailAddress.errors }" />
            <div *ngIf="submitted && f.emailAddress.errors" class="invalid-feedback">
              <div *ngIf="f.emailAddress.errors.required">This field is required</div>
              <div *ngIf="f.emailAddress.errors.maxlength">This field must not be at greater 255 characters</div>
              <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
            </div>
          </div>
        </div>
      </div>



      <div class="row lightgraybackground mt-4">
        <div class="col-md-12 text-center">
          Policy Information
        </div>
      </div>


      <div class="card card-body mt-4" style="background-color: #e7e7e7">
        <div class="row mb-3">
          <div class="col-md-10">
            <button type="button" (click)="addPolicyDetail()" class="btn btn-success">Add Policy Detail</button>&nbsp;&nbsp;&nbsp;
            <span style="font-size:1.1em; font-weight:bold">Please Press the “Add Policy Detail” to add additional items.</span>
          </div>
        </div>
        <div formArrayName="policyDetails" *ngFor="let policyDetail of policyDetails().controls; let i = index">
          <div [formGroupName]="i">
            <div style="border: 1px solid black; padding-left: 1%; padding-right: 1%; padding-top: 1%; padding-bottom: 1%">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="font-bold" for="lloydsSyndicateName">Name(s) of Lloyd’s Syndicate(s):</label>
                    <input type="text" class="form-control" formControlName="lloydsSyndicateName" placeholder="" autocomplete="no" trim="blur"
                           [ngClass]="{'is-invalid': policyDetailARR(i).controls['lloydsSyndicateName'].errors && (policyDetailARR(i).controls['lloydsSyndicateName'].dirty ||
                   policyDetailARR(i).controls['lloydsSyndicateName'].touched || policyDetailARR(i).controls['lloydsSyndicateName'].pristine)}" />
                    <div *ngFor="let validation of validation_PolicyDetailsErrorMessage.lloydsSyndicateName" class="invalid-feedback">
                      <div *ngIf="policyDetailARR(i).controls['lloydsSyndicateName'].hasError(validation.type) && (policyDetailARR(i).controls['lloydsSyndicateName'].dirty ||
             policyDetailARR(i).controls['lloydsSyndicateName'].touched || policyDetailARR(i).controls['lloydsSyndicateName'].pristine)">
                        {{ validation.message }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="font-bold" for="policyNumber">Policy Number:</label>
                    <input type="text" class="form-control" formControlName="policyNumber" placeholder="" autocomplete="no" trim="blur"
                           [ngClass]="{'is-invalid': policyDetailARR(i).controls['policyNumber'].errors && (policyDetailARR(i).controls['policyNumber'].dirty ||
                                 policyDetailARR(i).controls['policyNumber'].touched || policyDetailARR(i).controls['policyNumber'].pristine)}" />
                    <div *ngFor="let validation of validation_PolicyDetailsErrorMessage.policyNumber" class="invalid-feedback">
                      <div *ngIf="policyDetailARR(i).controls['policyNumber'].hasError(validation.type) && (policyDetailARR(i).controls['policyNumber'].dirty ||
                           policyDetailARR(i).controls['policyNumber'].touched || policyDetailARR(i).controls['policyNumber'].pristine)">
                        {{ validation.message }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="font-bold" for="totalPremiumPaid">
                      Total Premium Paid ($000,000,000.00):
                    </label>
                    <input type="text" class="form-control" formControlName="totalPremiumPaid" placeholder="" autocomplete="no" trim="blur"
                           [ngClass]="{'is-invalid': policyDetailARR(i).controls['totalPremiumPaid'].errors && (policyDetailARR(i).controls['totalPremiumPaid'].dirty ||
                              policyDetailARR(i).controls['totalPremiumPaid'].touched || policyDetailARR(i).controls['totalPremiumPaid'].pristine)}" />
                    <div *ngFor="let validation of validation_PolicyDetailsErrorMessage.totalPremiumPaid" class="invalid-feedback">
                      <div *ngIf="policyDetailARR(i).controls['totalPremiumPaid'].hasError(validation.type) && (policyDetailARR(i).controls['totalPremiumPaid'].dirty ||
                              policyDetailARR(i).controls['totalPremiumPaid'].touched || policyDetailARR(i).controls['totalPremiumPaid'].pristine)">
                        {{ validation.message }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="font-bold" for="policyDate">
                      Date of Policy (MM/DD/YYYY):
                    </label>
                    <input type="text" class="form-control" formControlName="policyDate" onkeydown="event.preventDefault()" bsDatepicker [bsConfig]="policyDatePickerConfig"
                           [ngClass]="{'is-invalid': policyDetailARR(i).controls['policyDate'].errors && (policyDetailARR(i).controls['policyDate'].dirty ||
                           policyDetailARR(i).controls['policyDate'].touched || policyDetailARR(i).controls['policyDate'].pristine)}" />
                    <div *ngFor="let validation of validation_PolicyDetailsErrorMessage.policyDate" class="invalid-feedback">
                      <div *ngIf="policyDetailARR(i).controls['policyDate'].hasError(validation.type) && (policyDetailARR(i).controls['policyDate'].dirty ||
                           policyDetailARR(i).controls['policyDate'].touched || policyDetailARR(i).controls['policyDate'].pristine)">
                        {{ validation.message }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="font-bold" for="brokerName">Broker Name:</label>
                    <input type="text" class="form-control" formControlName="brokerName" placeholder="" autocomplete="no" trim="blur"
                           [ngClass]="{'is-invalid': policyDetailARR(i).controls['brokerName'].errors && (policyDetailARR(i).controls['brokerName'].dirty ||
                 policyDetailARR(i).controls['brokerName'].touched || policyDetailARR(i).controls['brokerName'].pristine)}" />
                    <div *ngFor="let validation of validation_PolicyDetailsErrorMessage.brokerName" class="invalid-feedback">
                      <div *ngIf="policyDetailARR(i).controls['brokerName'].hasError(validation.type) && (policyDetailARR(i).controls['brokerName'].dirty ||
               policyDetailARR(i).controls['brokerName'].touched || policyDetailARR(i).controls['brokerName'].pristine)">
                        {{ validation.message }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="font-bold" for="brokerStreetAddress">Broker Street Address:</label>
                    <input type="text" class="form-control" formControlName="brokerStreetAddress" placeholder="" autocomplete="no" trim="blur"
                           [ngClass]="{'is-invalid': policyDetailARR(i).controls['brokerStreetAddress'].errors && (policyDetailARR(i).controls['brokerStreetAddress'].dirty ||
                 policyDetailARR(i).controls['brokerStreetAddress'].touched || policyDetailARR(i).controls['brokerStreetAddress'].pristine)}" />
                    <div *ngFor="let validation of validation_PolicyDetailsErrorMessage.brokerStreetAddress" class="invalid-feedback">
                      <div *ngIf="policyDetailARR(i).controls['brokerStreetAddress'].hasError(validation.type) && (policyDetailARR(i).controls['brokerStreetAddress'].dirty ||
               policyDetailARR(i).controls['brokerStreetAddress'].touched || policyDetailARR(i).controls['brokerStreetAddress'].pristine)">
                        {{ validation.message }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="font-bold" for="brokerCity">Broker City:</label>
                    <input type="text" class="form-control" formControlName="brokerCity" placeholder="" autocomplete="no" trim="blur"
                           [ngClass]="{'is-invalid': policyDetailARR(i).controls['brokerCity'].errors && (policyDetailARR(i).controls['brokerCity'].dirty ||
                                 policyDetailARR(i).controls['brokerCity'].touched || policyDetailARR(i).controls['brokerCity'].pristine)}" />
                    <div *ngFor="let validation of validation_PolicyDetailsErrorMessage.brokerCity" class="invalid-feedback">
                      <div *ngIf="policyDetailARR(i).controls['brokerCity'].hasError(validation.type) && (policyDetailARR(i).controls['brokerCity'].dirty ||
                           policyDetailARR(i).controls['brokerCity'].touched || policyDetailARR(i).controls['brokerCity'].pristine)">
                        {{ validation.message }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="font-bold" for="brokerState">
                      Broker State
                    </label>
                    <select class="form-control" formControlName="brokerState" [ngClass]="{'is-invalid': policyDetailARR(i).controls['brokerState'].errors && (policyDetailARR(i).controls['brokerState'].dirty ||
                                policyDetailARR(i).controls['brokerState'].touched || policyDetailARR(i).controls['brokerState'].pristine)}">
                      <option value="">Please Select A State</option>
                      <option *ngFor="let allstate of allStates">
                        {{allstate.Name}}
                      </option>
                    </select>
                    <!--<input type="text" class="form-control" formControlName="brokerState" placeholder="" autocomplete="no" trim="blur"
                           [ngClass]="{'is-invalid': policyDetailARR(i).controls['brokerState'].errors && (policyDetailARR(i).controls['brokerState'].dirty ||
                              policyDetailARR(i).controls['brokerState'].touched || policyDetailARR(i).controls['brokerState'].pristine)}" />-->
                    <div *ngFor="let validation of validation_PolicyDetailsErrorMessage.brokerState" class="invalid-feedback">
                      <div *ngIf="policyDetailARR(i).controls['brokerState'].hasError(validation.type) && (policyDetailARR(i).controls['brokerState'].dirty ||
                              policyDetailARR(i).controls['brokerState'].touched || policyDetailARR(i).controls['brokerState'].pristine)">
                        {{ validation.message }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="font-bold" for="brokerZipCode">
                      Broker Zip Code:
                    </label>
                    <input type="text" class="form-control" formControlName="brokerZipCode" placeholder="" autocomplete="no" trim="blur"
                           [ngClass]="{'is-invalid': policyDetailARR(i).controls['brokerZipCode'].errors && (policyDetailARR(i).controls['brokerZipCode'].dirty ||
                           policyDetailARR(i).controls['brokerZipCode'].touched || policyDetailARR(i).controls['brokerZipCode'].pristine)}" />
                    <div *ngFor="let validation of validation_PolicyDetailsErrorMessage.brokerZipCode" class="invalid-feedback">
                      <div *ngIf="policyDetailARR(i).controls['brokerZipCode'].hasError(validation.type) && (policyDetailARR(i).controls['brokerZipCode'].dirty ||
                           policyDetailARR(i).controls['brokerZipCode'].touched || policyDetailARR(i).controls['brokerZipCode'].pristine)">
                        {{ validation.message }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="font-bold" for="brokerPhoneNumber">
                      Broker Phone Number:
                    </label>
                    <input type="text" class="form-control" mask="(000) 000-0000" [showMaskTyped]="true" formControlName="brokerPhoneNumber" placeholder="" autocomplete="no" trim="blur"
                           [ngClass]="{'is-invalid': policyDetailARR(i).controls['brokerPhoneNumber'].errors && (policyDetailARR(i).controls['brokerPhoneNumber'].dirty ||
                           policyDetailARR(i).controls['brokerPhoneNumber'].touched || policyDetailARR(i).controls['brokerPhoneNumber'].pristine)}" />
                    <div *ngFor="let validation of validation_PolicyDetailsErrorMessage.brokerPhoneNumber" class="invalid-feedback">
                      <div *ngIf="policyDetailARR(i).controls['brokerPhoneNumber'].hasError(validation.type) && (policyDetailARR(i).controls['brokerPhoneNumber'].dirty ||
                           policyDetailARR(i).controls['brokerPhoneNumber'].touched || policyDetailARR(i).controls['brokerPhoneNumber'].pristine)">
                        {{ validation.message }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-6">
                  <button type="button" class="btn btn-danger" (click)="removePolicyDetail(i)">Remove</button>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div *ngIf="showDivAddPolicyDetailsMessage == true" class="custom-error-two">
            You must add at least one record
          </div>
        </div>
      </div>
      <div class="row lightgraybackground mt-4">
        <div class="col-md-12 text-center">
          Acknowledge And Submit
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          <!--Through the submission of this form, I attest under the penalty of perjury that the broker-dealer listed above has received notice of the class action Settlement in
          this case and is a member of the class of persons described in the notice.  I further attest that I am authorized to request exclusion from the Settlement in <i>
            Veritas
            Independent Partners, LLC v. The Ohio National Life Insurance Company, et al.,
          </i> Case No. 1:18-cv-769 on behalf of that broker-dealer and that I request exclusion.
          By signing below, I agree to the submission of this Opt-Out Form.<br /><br />-->
          <!--IF SUBMITTED ELECTRONICALLY: <br />-->
          <div class="form-group form-check">
            <input type="checkbox" formControlName="acknowledgement" class="form-check-input" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.acknowledgement.errors }" />
            <label for="acknowledgement">
              <b>I certify under the penalty of perjury that the information above is true and correct and that the submission of false information may subject me to civil and/or criminal penalties.</b>
            </label>
            <div *ngIf="submitted && f.acknowledgement.errors" class="invalid-feedback">
              <div *ngIf="f.acknowledgement.errors.required">This field is required</div>
            </div>
            <!--<div *ngFor="let validation of validation_FormErrorMessages.acknowledgement" class="invalid-feedback">
              <div *ngIf="f.acknowledgement.hasError(validation.type) && (f.acknowledgement.dirty || f.acknowledgement.touched || f.acknowledgement.pristine)">
                {{ validation.message }}
              </div>
            </div>-->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="signature"><b>Electronic Signature:</b> <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': submitted && f.signature.errors }" />
            <div *ngIf="submitted && f.signature.errors" class="invalid-feedback">
              <div *ngIf="f.signature.errors.required">This field is required</div>
              <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.signature.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens,
                brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group">
            <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" ngDefaultControl [ngClass]="{ 'is-invalid': submitted && f.googleRecaptchaToken.errors }"></re-captcha>
            <div *ngIf="submitted && f.googleRecaptchaToken.errors">
              <div *ngIf="f.googleRecaptchaToken.errors.required" class="custom-error">This field is required</div>
            </div>
          </div>
        </div>
      </div>
      <ul class="list-inline text-center">
        <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
      </ul>
    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
  </div>
</div>
